export default __webpack_public_path__ + "static/thunder-blacklc-c3b0eb03d6f3b75f34bee111c41cef5a.woff";